<dx-box
  #portalDashboard
  width="100%"
  height="100%"
  direction="col"
  class="user-dashboard-container"
>
  <dxi-item [ratio]="1" *ngIf="!isLoadComplete">
    <div class="dashboard-content-wrapper">
      <div class="dashboard-main-content">
        <div class="skeleton-header"></div>
        <div
          class="dashboard-grid"
          [ngClass]="{ 'dashboard-grid-mobile': isSmallScreen }"
        >
          <div class="dashboard-left-column">
            <div class="skeleton-card skeleton-card-large"></div>
            <div class="skeleton-card skeleton-card-small"></div>
            <div class="skeleton-card skeleton-card-small"></div>
            <div class="skeleton-card skeleton-card-medium"></div>
          </div>
          <div class="dashboard-right-column">
            <div class="skeleton-card skeleton-card-activity"></div>
          </div>
        </div>
      </div>
    </div>
  </dxi-item>
  <dxi-item [ratio]="1" *ngIf="!!isLoadComplete">
    <div *ngIf="!!showUserDashboard" class="dashboard-content-wrapper">
      <div class="dashboard-main-content">
        <h2 class="page-header">My Dashboard</h2>

        <!-- Announcement Skeleton -->
        <div *ngIf="isLoadingAnnouncement" class="latest-announcement-section">
          <div class="skeleton-card skeleton-card-announcement"></div>
        </div>

        <!-- Announcement Card -->
        <div
          *ngIf="!isLoadingAnnouncement && latestAnnouncement"
          class="latest-announcement-section"
        >
          <div
            class="latest-announcement-card"
            [ngClass]="{ 'latest-announcement-card-mobile': isSmallScreen }"
          >
            <div *ngIf="isSmallScreen" class="latest-announcement-header">
              <div class="latest-announcement-icon">
                <app-icon name="speaker" size="30px" color="#ff7350"></app-icon>
              </div>
              <div class="latest-announcement-date">
                {{
                  getAnnouncementFormattedDate(latestAnnouncement.releaseDate)
                }}
              </div>
            </div>
            <div *ngIf="!isSmallScreen" class="latest-announcement-icon">
              <app-icon name="speaker" size="75px" color="#ff7350"></app-icon>
            </div>
            <div class="latest-announcement-content">
              <div *ngIf="!isSmallScreen" class="latest-announcement-date">
                {{
                  getAnnouncementFormattedDate(latestAnnouncement.releaseDate)
                }}
              </div>
              <div
                class="latest-announcement-title"
                [ngClass]="{ 'line-clamp-1': !isSmallScreen }"
              >
                {{ latestAnnouncement.title }}
              </div>
              <div
                class="latest-announcement-preview"
                [ngClass]="{ 'line-clamp-1': !isSmallScreen }"
              >
                {{ latestAnnouncementPlainText }}
              </div>
              <a
                class="latest-announcement-link"
                (click)="onViewAllAnnouncementsClick()"
              >
                View All Announcements
              </a>
            </div>
          </div>
        </div>

        <div
          class="dashboard-grid"
          [ngClass]="{ 'dashboard-grid-mobile': isSmallScreen }"
        >
          <div class="dashboard-left-column">
            <app-user-dashboard-item
              *ngIf="!!accountBalanceItem"
              [dashboardItem]="accountBalanceItem"
              [elementId]="10"
              [isCompact]="true"
              (navigateToLink)="onDashboardItemClick($event)"
            ></app-user-dashboard-item>

            <app-user-dashboard-item
              *ngIf="!!complianceItem"
              [dashboardItem]="complianceItem"
              [elementId]="1"
              [isCompact]="true"
              (navigateToLink)="onDashboardItemClick($event)"
            ></app-user-dashboard-item>

            <app-user-dashboard-item
              *ngIf="!!documentsItem"
              [dashboardItem]="documentsItem"
              [elementId]="3"
              [isCompact]="true"
              (navigateToLink)="onDashboardItemClick($event)"
            ></app-user-dashboard-item>

            <app-user-dashboard-item
              *ngIf="!!architecturalItem"
              [dashboardItem]="architecturalItem"
              [elementId]="2"
              [isCompact]="true"
              (navigateToLink)="onDashboardItemClick($event)"
            ></app-user-dashboard-item>

            <app-user-dashboard-item
              [dashboardItem]="quickLinksItem"
              [isQuickLinks]="true"
              [isCompact]="true"
            ></app-user-dashboard-item>
          </div>

          <div class="dashboard-right-column">
            <app-user-dashboard-item
              [dashboardItem]="activityItem"
              [isActivityList]="true"
              (navigateToLink)="onDashboardItemClick($event)"
            ></app-user-dashboard-item>

            <app-meeting-hub-widget
              [selectedProperty]="selectedProperty"
            ></app-meeting-hub-widget>

            <app-my-community-tile
              [selectedProperty]="selectedProperty"
            ></app-my-community-tile>
          </div>
        </div>
      </div>
      <div class="version-display">
        {{ appVersion }}
      </div>
    </div>
    <dx-box
      *ngIf="!showUserDashboard"
      width="100%"
      height="100%"
      direction="col"
      [align]="'center'"
    >
      <dxi-item [ratio]="1" *ngIf="!isSmallScreen"></dxi-item>
      <dxi-item baseSize="auto">
        <dx-box width="100%" height="100%" [align]="'center'" direction="row">
          <dxi-item [ratio]="1" *ngIf="!isSmallScreen"></dxi-item>
          <dxi-item baseSize="auto">
            <app-user-dashboard-item
              [dashboardItem]="emptyItem"
            ></app-user-dashboard-item>
          </dxi-item>
          <dxi-item [ratio]="1" *ngIf="!isSmallScreen"></dxi-item>
        </dx-box>
      </dxi-item>
      <dxi-item [ratio]="1" *ngIf="!isSmallScreen"></dxi-item>
    </dx-box>
  </dxi-item>
</dx-box>

<dx-load-panel
  [position]="{ of: '#portalDashboard' }"
  [visible]="loadingVisible && isLoadComplete"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>

<app-portal-announcement #announcements></app-portal-announcement>
